<div class="kyc-verification-error">
  <ng-container *ngIf="!isLoading">
    <img src="assets/icons/error-warning.svg" alt="Icono Error" />
    <h4>¡Será en otra ocasión!</h4>
    <p>
      Basándonos en los datos que nos facilitaste, no podemos ofrecerte la posibilidad de aplazar la
      compra con nosotros.
    </p>
    <div>
      <button class="btn-primary-bg" (click)="onKillPurchase()">Volver al comercio</button>
    </div>
  </ng-container>
  <ng-container *ngIf="isLoading">
    <div class="kyc-verification-error">
      <layout-skeleton [data]="skeletonInfo[0]"></layout-skeleton>
      <layout-skeleton [data]="skeletonInfo[1]"></layout-skeleton>
      <layout-skeleton [data]="skeletonInfo[0]"></layout-skeleton>
    </div>
  </ng-container>
</div>
